import {DataLoading} from '../../components/data-loading/data-loading'
export function LoadingData(): JSX.Element {
    return <DataLoading />
}
